import { render, staticRenderFns } from "./GItemEdit.vue?vue&type=template&id=00352a24&scoped=true&"
import script from "./GItemEdit.vue?vue&type=script&lang=ts&"
export * from "./GItemEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GItemEdit.vue?vue&type=style&index=0&id=00352a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00352a24",
  null
  
)

export default component.exports